const relevancy = {
    en: {
      relevancy:{
        name: "Relevancies",
        scope: {
          Default: "Client/ Default",
          RTA: "RTA",
          Coding: "Coding",
          ER: "ER",
          Social: "Social",
          Curation: "Curation"
        },
        form: {
          labels: {
            position: 'Position',
            tags: 'Tags',
            weight: 'Weight',
            medium_lower_limit: 'Medium Lower',
            medium_upper_limit: 'Medium Upper',
            low_upper_limit: 'Low Upper',
            high_upper_limit: 'High Upper',
            high_lower_limit: 'High Lower',
            critical_limit: 'Most Relevant'
          },
          buttons:{
            save: 'Save Changes',
            cancel: 'Cancel',
            create: 'Create',
            reset: 'Reset',
            delete: 'Delete',
            section_save: 'Save'
          },
          auto_assign:{
            title: 'Relevancy',
            multi_select: 'Select...',
            critical_limit: 'Most Relevant',
            high_limit: 'High',
            medium_limit: 'Medium',
            low_limit: 'Low',
            select_relevancy: 'Select a relevancy',
            relevancy_required: 'Please select at least one Relevancy value when Scope and Name are set.',
            na: 'N/A'
          },
        },
        table: {
          headline_and_content: 'Headline and content',
          rest_of_text: 'Rest of the text',
          headline: 'Headline',
          first_paragraph: 'First Paragraph',
          position: 'Position',
          tags: 'Tags',
          weight: 'Weight',
          relevancy_mapping: 'Mapping',
          medium_limit: 'Medium',
          low_limit: 'Low',
          high_limit: 'High',
          critical_limit: 'Most Relevant'

        },
        modal: {
          title: 'Confirm Delete',
          message: 'Are you sure you want to delete?',
          reset_title: 'Reset Confirmation',
          delete_message: 'Are you sure you want to delete?',
          delete_confirmation_title: "Delete",
          reset_message: 'Are you sure you want to proceed with the reset? This action will delete all current setups and revert the system to its default mode.'
        },
        history: {
          name: "Name",
          last_activity: 'Last Activity',
          createRelevancy: 'Created',
          updateRelevancy: 'Updated',
          created_by: 'by',
          added: 'Added',
          deleted: 'Deleted',
          weight: 'Weight',
          tags: 'Tags',
          headline: 'Headline',
          headline_and_content: 'Full Text Ex: Direct mentions',
          rest_of_text: 'Full Text Ex: Industry mentions',
          first_paragraph: 'First Paragraph',
          high_upper_limit: 'High Upper Limit',
          medium_upper_limit: 'Medium Upper Limit',
          low_upper_limit: 'Low Upper Limit'
        }
      }
    }
  }
  
  module.exports.relevancy = relevancy;